module.exports = __webpack_public_path__ + "img/Group-4737.d6a691be.svg";